package com.solevo.dist

import androidx.compose.runtime.Composable
import com.solevo.dist.di.DI
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.init.registerStyleBase
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.toModifier
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.apps
import dev.gitlive.firebase.initialize
import com.solevo.dist.i18n.LocalizationProvider

private var firebaseInitialized = false

@InitSilk
fun initStyles(ctx: InitSilkContext) {
    // Load runtime config.js synchronously before Firebase/DI init
    loadConfigJs()

    // Add Inter font CSS link
    kotlinx.browser.document.head?.let { head ->
        val link = kotlinx.browser.document.createElement("link") as org.w3c.dom.HTMLLinkElement
        link.rel = "stylesheet"
        link.href = "/fonts/faces.css"
        head.appendChild(link)
    }

    ctx.stylesheet.registerStyleBase("html, body") {
        Modifier
            .fillMaxHeight()
            .fontFamily("Inter", "sans-serif")
    }
    ensureFirebaseInitialized()
    DI.start()
}

private fun loadConfigJs() {
    // Skip if config is already loaded (e.g. via script tag in HTML)
    if (js("typeof window.__APP_CONFIG__ !== 'undefined'") as Boolean) return

    val xhr = org.w3c.xhr.XMLHttpRequest()
    xhr.open("GET", "/config.js", async = false)
    xhr.send()
    if (xhr.status == 200.toShort()) {
        js("eval")(xhr.responseText)
    } else {
        console.error("Failed to load /config.js: HTTP ${xhr.status}")
    }
}

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    SilkApp {
        Surface(SmoothColorStyle.toModifier().fillMaxHeight()) {
            LocalizationProvider {
                content()
            }
        }
    }
}


fun ensureFirebaseInitialized() {
    if (firebaseInitialized) return
    if (runCatching { Firebase.apps().isNotEmpty() }.getOrDefault(false)) {
        firebaseInitialized = true
        return
    }
    Firebase.initialize(
        options = FirebaseOptions(
            applicationId = AppConfig.Firebase.APP_ID,
            apiKey = AppConfig.Firebase.API_KEY,
            projectId = AppConfig.Firebase.PROJECT_ID,
            gcmSenderId = AppConfig.Firebase.APP_ID.split(":").getOrNull(1) ?: "",
            storageBucket = "${AppConfig.Firebase.PROJECT_ID}.appspot.com",
            databaseUrl = null
        )
    )
    firebaseInitialized = true
}
